import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { graphql } from "gatsby";
//import { getImage, GatsbyImage } from "gatsby-plugin-image";
import Seo from "gatsby-plugin-wpgraphql-seo";

//Custom Imports
//import { blockRendererComponent } from "../config/blockRendererComponent";
import { Banner, DiagnosisTests, ImageContent, Layout } from "../components";

const PrecisionDiabetes = ({
  pageContext,
  data: {
    wpPage,
    wpPage: {
      pageMeta,
      content,
      servicesMeta: { contents },
      precisionMeta,
    },
  },
}) => {
  console.log(precisionMeta);
  return (
    <>
      <Seo post={wpPage} />
      <Layout>
        <Banner banner={pageMeta.pageBanner} />
        {contents?.map((content, index) => {
          if (
            content.fieldGroupName === "Page_Servicesmeta_Contents_ImageContent"
          ) {
            return (
              <section className={`overflow-hidden bg-white py-12`} key={index}>
                <div className="container mx-auto">
                  {content.fieldGroupName ===
                    "Page_Servicesmeta_Contents_ImageContent" && (
                    <ImageContent data={content} />
                  )}
                </div>
              </section>
            );
          } else if (
            content.fieldGroupName ===
            "Page_Servicesmeta_Contents_DiagnosisAndTest"
          ) {
            return (
              <section className={`overflow-hidden bg-white py-12`} key={index}>
                <div className="container mx-auto">
                  <DiagnosisTests data={content} />
                </div>
              </section>
            );
          } else {
            return "";
          }
        })}
        <section className="bg-white py-12">
          <div className="container mx-auto">
            <div className="px-4 pb-12">
              <h2 className="mb-8 text-center font-openSans text-2xl text-secondary 2xl:text-4xl">
                What makes us a #1 diabetes specialities centre in India?
              </h2>
              <p className="mb-8 text-center font-openSans text-xl text-black 2xl:text-2xl">
                When you turn to DMDSC, you’re choosing the best diabetes
                treatment solutions. Below are some numbers that speak volumes
                about our centre:
              </p>
              <Swiper
                spaceBetween={0}
                slidesPerView={1}
                autoplay={{ delay: 7500, disableOnInteraction: false }}
                modules={[Navigation, Autoplay]}
                breakpoints={{
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                  },
                }}
                className="pb-8"
              >
                {precisionMeta.slider?.map((slide, index) => {
                  console.log(slide);
                  return (
                    <SwiperSlide key={index} className="h-auto">
                      <div
                        className="post-content flex h-full items-center justify-center bg-altbg p-4 text-center font-openSans text-lg text-black hover:bg-primary hover:text-white"
                        dangerouslySetInnerHTML={{
                          __html: slide.content,
                        }}
                      ></div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default PrecisionDiabetes;

export const query = graphql`
  query PageQuery($id: Int) {
    wpPage(databaseId: { eq: $id }) {
      content
      servicesMeta {
        contents {
          ... on WpPage_Servicesmeta_Contents_ImageContent {
            content
            fieldGroupName
            title
            imagePosition
            buttons {
              blueButton
              buttonData {
                target
                title
                url
              }
            }
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
          }
          ... on WpPage_Servicesmeta_Contents_DiagnosisAndTest {
            fieldGroupName
            title
            type
            slider {
              title
              content
              button {
                target
                title
                url
              }
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                  }
                }
              }
            }
          }
        }
      }
      pageMeta {
        pageBanner {
          desktopImage {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
              }
            }
          }
          mobileImage {
            localFile {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
              }
            }
          }
          captionTitle
          captionContent
          buttonLink
          buttonLabel
          showWhiteLogo
          whiteColor
          position
        }
      }
      precisionMeta {
        slider {
          content
        }
      }
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
    }
  }
`;
